import React from "react";
import { Link } from "react-router-dom";
import { Hero, Section, CTA } from "../components/Page/Page.js";
import { posts } from "../data/posts.js";

export default function InsightsScreen() {
  return (
    <>
      <Hero eyebrow="Insights" title="Notes from the carbon market" text="Short, practical reads on credits, projects and climate strategy." />
      <Section>
        <div className="pg-links">
          {posts.map((p) => (
            <Link key={p.slug} to={`/insights/${p.slug}`}>
              <span>{p.title}</span>
              <small className="pg-post-meta">{p.tag}</small>
            </Link>
          ))}
        </div>
      </Section>
      <CTA />
    </>
  );
}
